import auth from '../../../src/api/auth'
import * as types from '../mutation-types/auth'
import router from '@/router';
import axios from '@/api/axios'

// initial state
const state = {
    isLogged: (() => {
        // @TODO do the math how much time last
        return localStorage.getItem('auth.token') ? true : false
    }),
    token: localStorage.getItem('auth.token') || "",
    email: localStorage.getItem('auth.email') || "",
    name: localStorage.getItem('auth.name') || "",
    role: localStorage.getItem('auth.role') || "",
    errors: [],
}

// getters
const getters = {
    isAuthenticated: state => !!state.token,
}

// actions
const actions = {
    login({ commit }, { email, password }) {
        auth.login({ email, password })
            .then(data => {
                if(!data.error){
                    commit(types.SET_TOKEN, data.token)
                    commit(types.SET_USER, {
                        email: data.email,
                        name: data.name,
                        role: data.role,
                        user_id: data.user_id,
                    })
                    commit(types.IS_LOGGED)
                    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

                    if (data.role != "admin")
                        router.push("/admin/Documents/Index");
                    else
                        router.push("/admin/Home");
                } else {
                    commit(types.ISNT_LOGGED);
                }
            })
            .catch(() => {
                commit(types.ISNT_LOGGED);
            })
    }
}

// mutations
const mutations = {
    [types.IS_LOGGED](state) {
        state.isLogged = true
    },

    [types.ISNT_LOGGED](state) {
        state.isLogged = false
    },

    [types.SET_TOKEN](state, token) {
        state.token = token
        localStorage.setItem('auth.token', token)
    },

    [types.SET_USER](state, { email, name, role, user_id }) {
        state.email = email
        state.name = name
        state.role = role
        state.user_id = user_id
        localStorage.setItem('auth.email', email)
        localStorage.setItem('auth.name', name)
        localStorage.setItem('auth.role', role)
        localStorage.setItem('auth.user_id', user_id)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
